const punycode = require('punycode/');

function isPunycode(hostname) {
  if (typeof hostname !== 'string' || hostname.length === 0) {
    return false;
  }
  return hostname.toLowerCase().startsWith('xn--');
}

export default ({ req }, inject) => {
  let currentDomain = null;

  if (process.server) {
    currentDomain = req.headers.host;
  } else {
    currentDomain = window.location.hostname;
  }

  if (isPunycode(currentDomain)) {
    currentDomain = punycode.toUnicode(currentDomain)
  }

  inject('currentDomain', currentDomain);
}
